import { requestStatusTypes } from "./requestStatusTypes";

export const requestApprovalStatusNotIsDemandOptions = [
  {
    label: "Đang đợi duyệt",
    value: requestStatusTypes.submitted,
  },
  // {
  //   label: "Đang đợi duyệt",
  //   value: requestStatusTypes.preApproved,
  // },
  {
    label: "Đã duyệt",
    value: requestStatusTypes.approved,
  },
  {
    label: "Đang thực hiện",
    value: requestStatusTypes.inProgress,
  },
  {
    label: "Tiến hành nghiệm thu",
    value: requestStatusTypes.acceptance,
  },
  {
    label: "Đã hoàn tất",
    value: requestStatusTypes.completed,
  },
  {
    label: "Đã bị từ chối",
    value: requestStatusTypes.rejected,
  },
];
